// Generate URL of responsive image from original URL
// Ex: ff.com/img-default.jpg, 1200w => ff.com/responsive/img-1200w.jpg

export default (originalUrl, size) => {
  if (!originalUrl) {
    return '';
  }

  let url = originalUrl;

  // Support for responsive images
  if (url && url.includes('-default.')) {
    const getPathRegEx = /\/(?=[^/]*$)/;
    const getFilenameRegEx = /-default\.(?=.{3,4}$)/;

    const [path, filename] = originalUrl.split(getPathRegEx);
    const [baseFilename, extension] = filename.split(getFilenameRegEx);

    const responsivePath = path.concat('/responsive');

    url = `${responsivePath}/${baseFilename}-${size}.${extension}`;
  }

  return `url(${url})`;
};
